import { classes } from 'html-classes';

import { company } from '~/company/Company';
import { ProductCardSkeletonProps } from '~/components/ProductCardV3/skeletons/types';

import styles from './ProductCardSkeletonS.module.scss';

/**
 * ProductCardSkeletonS - Loading skeleton for ProductCardS
 * Matches dimensions of ProductCardS (96px mobile, 164px web)
 */
const ProductCardSkeletonS = ({ className }: ProductCardSkeletonProps) => {
  return (
    <div
      className={classes([styles.skeleton, className])}
      data-company={company.name}
    >
      {/* Image skeleton with bottom section */}
      <div className={styles.imageWrapper}>
        <div className={styles.bottomSection}>
          <div className={styles.buttonSkeleton} />
        </div>
      </div>

      {/* Info section skeleton */}
      <div className={styles.infoWrapper}>
        {/* Name lines */}
        <div className={styles.nameSection}>
          <div className={styles.nameLine} />
          <div className={classes([styles.nameLine, styles.nameLine_short])} />
        </div>

        {/* Price skeleton */}
        <div className={styles.priceSection}>
          <div className={styles.priceLine} />
          <div className={styles.priceLine} />
        </div>
      </div>
    </div>
  );
};

export default ProductCardSkeletonS;
